// API Endpoints
export const API_ENDPOINTS = {
    auth: {
        login: '/v1/auth/login',
        register: '/v1/auth/register',
        logout: '/v1/auth/logout',
        refresh: '/v1/auth/refresh',
        me: '/v1/user',
        profile: '/v1/user/profile',
        deleteAccount: '/v1/user/account',
        forgotPassword: '/v1/auth/forgot-password',
        resetPassword: '/v1/auth/reset-password',
        verifyEmailCode: '/v1/email/verify-code',
        resendEmail: '/v1/email/resend',
        // Public endpoints for unverified users (they cannot log in yet)
        verifyEmail: '/v1/auth/verify-email',
        resendVerificationEmail: '/v1/auth/resend-verification-email',
    },
    streams: {
        index: '/v1/streams',
        active: '/v1/streams/active',
        live: '/v1/streams/live',
        mine: '/v1/streams/mine',
        create: '/v1/streams',
        show: '/v1/streams/:id',
        update: '/v1/streams/:id',
        destroy: '/v1/streams/:id',
        start: '/v1/streams/:id/start',
        stop: '/v1/streams/:id/stop',
        end: '/v1/streams/:id/end',
        stats: '/v1/streams/:id/stats',
        viewers: '/v1/streams/:id/viewers',
        analytics: '/v1/analytics/:id',
        analyticsHourly: '/v1/streams/:id/analytics/hourly',
        analyticsDaily: '/v1/streams/:id/analytics/daily',
        sessions: '/v1/streams/:id/sessions',
        platformStreamDestroy: '/v1/platform-streams/:id',
    },
    videos: {
        index: '/v1/videos',
        store: '/v1/videos',
        show: '/v1/videos/:id',
        update: '/v1/videos/:id',
        destroy: '/v1/videos/:id',
        publicIndex: '/v1/videos',
        publicShow: '/v1/videos/:id',
        thumbnail: '/v1/videos/:id/thumbnail',
        clips: '/v1/videos/clips',
    },
    users: {
        profile: '/v1/user/:id',
        publicProfile: '/v1/users/:id/profile',
        search: '/v1/search',
        followers: '/v1/followers',
        following: '/v1/following',
        followStatus: '/v1/follow/status',
        follow: '/v1/follow',
        unfollow: '/v1/follow',
        photos: '/v1/photos',
        storePhoto: '/v1/photos',
        showPhoto: '/v1/photos/:id',
        destroyPhoto: '/v1/photos/:id',
    },
    social: {
        friends: '/v1/friends',
        friendRequests: '/v1/friends/requests',
        sendFriendRequest: '/v1/friends/:id/send',
        acceptFriendRequest: '/v1/friends/:id/accept',
        rejectFriendRequest: '/v1/friends/:id/reject',
        removeFriend: '/v1/friends/:id',
        searchUsers: '/v1/friends/search',
        friendSuggestions: '/v1/friends/suggestions',
        comments: '/v1/comments/:type/:id',
        storeComment: '/v1/comments',
        updateComment: '/v1/comments/:id',
        destroyComment: '/v1/comments/:id',
        indexComments: '/v1/comments/:type/:id',
        likes: '/v1/likes/:type/:id',
        storeLike: '/v1/likes',
        destroyLike: '/v1/likes',
        p2pConnections: '/v1/p2p/connections',
        p2pStatus: '/v1/p2p/status',
    },
    chat: {
        messages: '/v1/messages',
        sendMessage: '/v1/messages',
        streamMessages: '/v1/messages/stream',
        sendStreamMessage: '/v1/messages/stream',
        markRead: '/v1/messages/mark-read',
        markConversationRead: '/v1/messages/conversation/read',
        unreadCount: '/v1/messages/unread-count',
        conversations: '/v1/messages/conversations',
        lastMessage: '/v1/messages/last',
        typing: '/v1/messages/typing',
        markStreamRead: '/v1/messages/stream/mark-read',
    },
    notifications: {
        index: '/v1/notifications',
        unread: '/v1/notifications/unread',
        show: '/v1/notifications/:id',
        markRead: '/v1/notifications/:id/read',
        markAllRead: '/v1/notifications/read-all',
    },
    marketplace: {
        items: '/v1/marketplace',
        publicIndex: '/v1/marketplace',
        publicShow: '/v1/marketplace/:id',
        categories: '/v1/marketplace/categories',
        store: '/v1/marketplace',
        show: '/v1/marketplace/:id',
        update: '/v1/marketplace/:id',
        destroy: '/v1/marketplace/:id',
    },
    forum: {
        posts: '/v1/forum',
        categories: '/v1/forum/category',
        comments: '/v1/forum/:id/comment',
        store: '/v1/forum',
        show: '/v1/forum/:id',
        update: '/v1/forum/:id',
        destroy: '/v1/forum/:id',
    },
    subscriptions: {
        plans: '/v1/subscription/plans',
        current: '/v1/subscription/current',
        subscribe: '/v1/subscription/upgrade',
        cancel: '/v1/subscription/cancel',
        resume: '/v1/subscription/resume',
        webhook: '/v1/subscription/webhook',
        toggleAutoPay: '/v1/subscription/auto-pay/toggle',
    },
    payments: {
        history: '/v1/payments/history',
        store: '/v1/payments',
        stripe: '/v1/payments/stripe',
        paypal: '/v1/payments/paypal',
        donation: '/v1/donations',
        receivedDonations: '/v1/donations/received',
        sentDonations: '/v1/donations/sent',
    },
    analytics: {
        dashboard: '/v1/dashboard',
        streaming: '/v1/dashboard/streaming',
        analytics: '/v1/dashboard/analytics',
        show: '/v1/analytics/:id',
    },
    settings: {
        index: '/v1/settings',
        publicIndex: '/v1/public/settings',
        update: '/v1/settings',
        apiKey: '/v1/api-keys',
        createApiKey: '/v1/api-keys',
        destroyApiKey: '/v1/api-keys/:id',
        logoutOther: '/v1/settings/logout-other',
    },
    user: {
        profile: '/v1/user',
        show: '/v1/user/:id',
        updateProfile: '/v1/user/profile',
        updatePassword: '/v1/user/password',
        avatar: '/v1/user/avatar',
        coverImage: '/v1/user/cover-image',
        settings: '/v1/user/settings',
    },
    reports: {
        create: '/v1/report',
        list: '/v1/reports',
        status: '/v1/report/status',
        delete: '/v1/admin/content/reports/:id',
        stats: '/v1/admin/content/reports/stats',
    },
    twoFactor: {
        enable: '/v1/2fa/enable',
        confirm: '/v1/2fa/confirm',
        disable: '/v1/2fa/disable',
        verify: '/v1/2fa/verify',
        recoveryCodes: '/v1/2fa/recovery-codes',
        regenerateRecoveryCodes: '/v1/2fa/regenerate-recovery-codes',
    },
    admin: {
        analytics: {
            dashboard: '/v1/admin/analytics/dashboard',
            userGrowth: '/v1/admin/analytics/user-growth',
            streamAnalytics: '/v1/admin/analytics/stream-analytics',
            topStreams: '/v1/admin/analytics/top-streams',
            topUsers: '/v1/admin/analytics/top-users',
            revenue: '/v1/admin/analytics/revenue',
            health: '/v1/admin/analytics/health',
        },
        users: {
            index: '/v1/admin/users',
            show: '/v1/admin/users/:user',
            update: '/v1/admin/users/:user',
            ban: '/v1/admin/users/:user/ban',
            unban: '/v1/admin/users/:user/unban',
            promote: '/v1/admin/users/:user/promote',
            demote: '/v1/admin/users/:user/demote',
            verifyEmail: '/v1/admin/users/:user/verify-email',
            destroy: '/v1/admin/users/:user',
        },
        streams: {
            index: '/v1/admin/streams',
            show: '/v1/admin/streams/:stream',
            approve: '/v1/admin/streams/:stream/approve',
            suspend: '/v1/admin/streams/:stream/suspend',
            restore: '/v1/admin/streams/:stream/restore',
            destroy: '/v1/admin/streams/:stream',
            bulkApprove: '/v1/admin/streams/bulk-approve',
            bulkSuspend: '/v1/admin/streams/bulk-suspend',
        },
        content: {
            reports: '/v1/admin/content/reports',
            getReport: '/v1/admin/content/reports/:report',
            resolveReport: '/v1/admin/content/reports/:report/resolve',
            dismissReport: '/v1/admin/content/reports/:report/dismiss',
            deleteReport: '/v1/admin/content/reports/:report',
            reportStats: '/v1/admin/content/reports/stats',
            videos: '/v1/admin/content/videos',
            approveVideo: '/v1/admin/content/videos/:video/approve',
            rejectVideo: '/v1/admin/content/videos/:video/reject',
            destroyVideo: '/v1/admin/content/videos/:video',
            forum: '/v1/admin/content/forum',
            approveForum: '/v1/admin/content/forum/:forumPost/approve',
            rejectForum: '/v1/admin/content/forum/:forumPost/reject',
            destroyForum: '/v1/admin/content/forum/:forumPost',
            comments: '/v1/admin/content/comments',
            destroyComment: '/v1/admin/content/comments/:comment',
        },
        settings: '/v1/admin/settings',
        payments: '/v1/admin/payments',
    },
    health: '/v1/health',
} as const;

// Streaming Platforms
export const STREAMING_PLATFORMS = [
    {
        id: 'twitch',
        name: 'Twitch',
        icon: 'twitch',
        url: 'https://www.twitch.tv',
        supported: true,
        requiresKey: true,
    },
    {
        id: 'youtube',
        name: 'YouTube',
        icon: 'youtube',
        url: 'https://www.youtube.com',
        supported: true,
        requiresKey: true,
    },
    {
        id: 'facebook',
        name: 'Facebook',
        icon: 'facebook',
        url: 'https://www.facebook.com',
        supported: true,
        requiresKey: true,
    },
    {
        id: 'tiktok',
        name: 'TikTok',
        icon: 'tiktok',
        url: 'https://www.tiktok.com',
        supported: true,
        requiresKey: true,
    },
    {
        id: 'custom',
        name: 'Custom RTMP',
        icon: 'link',
        url: '',
        supported: true,
        requiresKey: false,
    },
] as const;

// Subscription Plans
export const SUBSCRIPTION_PLANS = [
    {
        id: 'free',
        name: 'Free',
        price: 0,
        currency: 'USD',
        duration: 'monthly',
        features: [
            '1 simultaneous stream',
            '720p streaming quality',
            '30-minute stream duration',
            'Basic analytics',
            '5GB video storage',
        ],
        limitations: [
            'Ads enabled',
            'No custom branding',
            'Limited to 1 platform',
        ],
        maxSimultaneousStreams: 1,
        maxQuality: '720p',
        maxDuration: 30,
        storageLimit: 5,
        isPopular: false,
    },
    {
        id: 'starter',
        name: 'Starter',
        price: 9.99,
        currency: 'USD',
        duration: 'monthly',
        features: [
            '2 simultaneous streams',
            '1080p streaming quality',
            '2-hour stream duration',
            'Advanced analytics',
            '50GB video storage',
            'Custom branding',
            'No ads',
        ],
        limitations: ['Limited to 3 platforms'],
        maxSimultaneousStreams: 2,
        maxQuality: '1080p',
        maxDuration: 120,
        storageLimit: 50,
        isPopular: false,
    },
    {
        id: 'pro',
        name: 'Pro',
        price: 29.99,
        currency: 'USD',
        duration: 'monthly',
        features: [
            '5 simultaneous streams',
            '4K streaming quality',
            '8-hour stream duration',
            'Premium analytics',
            '200GB video storage',
            'Custom branding',
            'No ads',
            'Priority support',
            'API access',
        ],
        limitations: ['Limited to 5 platforms'],
        maxSimultaneousStreams: 5,
        maxQuality: '4K',
        maxDuration: 480,
        storageLimit: 200,
        isPopular: true,
    },
    // Note: the 'life' and 'vip' plans are intentionally omitted here — they are
    // admin-only plans hidden from all public plan lists (see config/subscription.php
    // `is_admin_only` flag). Users holding them still see their own plan details
    // via /v1/subscription/current.
] as const;

// Video Effects
export const VIDEO_EFFECTS = [
    { id: 'blur', name: 'Blur', category: 'background' },
    { id: 'bokeh', name: 'Bokeh', category: 'background' },
    { id: 'color-grade', name: 'Color Grade', category: 'color' },
    { id: 'brightness', name: 'Brightness', category: 'color' },
    { id: 'contrast', name: 'Contrast', category: 'color' },
    { id: 'saturation', name: 'Saturation', category: 'color' },
    { id: 'vignette', name: 'Vignette', category: 'overlay' },
    { id: 'grain', name: 'Film Grain', category: 'overlay' },
    { id: 'chroma', name: 'Chroma Key', category: 'special' },
    { id: 'face-smooth', name: 'Face Smooth', category: 'beauty' },
    { id: 'beauty', name: 'Beauty Filter', category: 'beauty' },
    { id: 'edge-detect', name: 'Edge Detect', category: 'special' },
] as const;

// Video Overlays
export const VIDEO_OVERLAYS = [
    { id: 'webcam', name: 'Webcam', type: 'camera' },
    { id: 'scoreboard', name: 'Scoreboard', type: 'graphic' },
    { id: 'donation-alert', name: 'Donation Alert', type: 'notification' },
    { id: 'chat-box', name: 'Chat Box', type: 'widget' },
    { id: 'social-feed', name: 'Social Feed', type: 'widget' },
    { id: 'timer', name: 'Stream Timer', type: 'widget' },
    { id: 'watermark', name: 'Watermark', type: 'graphic' },
    { id: 'logo', name: 'Logo Overlay', type: 'graphic' },
] as const;

// Categories
export const CATEGORIES = [
    'Gaming',
    'Music',
    'Art',
    'Cooking',
    'Technology',
    'Education',
    'Entertainment',
    'Sports',
    'Fitness',
    'Travel',
    'Fashion',
    'Photography',
    'Science',
    'Politics',
    'Comedy',
    'Podcast',
    'Other',
] as const;

// Chat Colors
export const CHAT_COLORS = [
    '#3B82F6',
    '#22C55E',
    '#2196F3',
    '#4CAF50',
    '#FF9800',
    '#FF5722',
    '#00BCD4',
    '#9C27B0',
    '#3F51B5',
    '#F44336',
] as const;

// Pagination
export const PAGINATION = {
    perPage: 15,
    perPageOptions: [5, 10, 15, 25, 50],
    maxPerPage: 100,
} as const;

// File Upload Limits
export const FILE_UPLOAD_LIMITS = {
    video: { maxSize: 2147483648, maxDuration: 28800, allowedTypes: ['video/mp4', 'video/webm', 'video/avi'] },
    image: { maxSize: 10485760, allowedTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'] },
    avatar: { maxSize: 5242880, allowedTypes: ['image/jpeg', 'image/png', 'image/gif'] },
    thumbnail: { maxSize: 2097152, allowedTypes: ['image/jpeg', 'image/png', 'image/webp'] },
} as const;

// WebSocket Events
export const WEBSOCKET_EVENTS = {
    streamStarted: 'stream.started',
    streamEnded: 'stream.ended',
    viewerConnected: 'viewer.connected',
    viewerDisconnected: 'viewer.disconnected',
    chatMessage: 'chat.message',
    donation: 'donation.received',
    like: 'like.received',
    friendRequest: 'friend.request',
    comment: 'comment.received',
    notification: 'notification.received',
} as const;
